module.exports = __webpack_public_path__ + "4ef5aa449b9c49709fee8a7a20558cf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/areas/areas-probate.jpg
// module id = 124
// module chunks = 0